import _get from 'lodash/get';
import _pickBy from 'lodash/pickBy';
import _identity from 'lodash/identity';
import { stringifyDate } from '@ott/utility-date';

export default (state, data) => {
  const {
    suggest: {
      pickUp: { actualValue: pSelectedPoint },
      dropOff: { actualValue: dSelectedPoint },
    },
    search: {
      commonParams: { currency, lang },
    },
  } = state;

  const { pickUpDate, dropOffDate, pickUpTime, dropOffTime, age, resellerId, isTest } = data;

  const pKey = _get(pSelectedPoint, 'key', null);
  const dKey = _get(dSelectedPoint, 'key', null);

  return _pickBy(
    {
      pDate: stringifyDate(pickUpDate),
      dDate: stringifyDate(dropOffDate),
      pTime: pickUpTime.replace(/:/, ''),
      dTime: dropOffTime.replace(/:/, ''),
      pKey,
      dKey,
      age,
      lang,
      currency,
      resellerId,
      isTest,
    },
    _identity
  );
};
